import { shallowMount } from "@vue/test-utils";
import AddressSelectOptions from "@/components/core/AddressSelectOptions";

describe("AddressSelectOptions component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(AddressSelectOptions);
  });

  it("Renders del component AddressSelectOptions", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
